<template>
  <div class="dashboard">
    <v-container>
      <v-layout row wrap align-center>
        <v-flex xs12 md4 pa-1 class="text-xs-right">
          <v-switch label="Revenue" small v-model="revenue" color="primary"></v-switch>
        </v-flex>
        <v-flex xs12 md4 pa-1>
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <v-select
            :items="dates"
            solo
            hint="*Statistics for all orders during this period"
            :persistent-hint="true"
            @change="loadOrders($store.state.user.company_code, selectedDate)"
            dense
            return-object
            v-model="selectedDate"
            label="Period"
          ></v-select>
        </v-flex>
        <v-flex xs12 md12 pa-3 v-if="loading">
          <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
      </v-layout>
      <v-layout row wrap >
        <v-flex xs12 md4 pa-1>
          <MiniStatistic
            :icon="'shopping_cart'"
            :color="'primary'"
            :title="orders"
            :path="`/inf-crm?orders=all`"
            :tooltip="'All orders occured during time period'"
            :subTitle="'Total Orders'"
          />
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <MiniStatistic
            :icon="'star'"
            :color="'primary'"
            :title="newOrders"
            :path="`/inf-crm?orders=new`"
            :tooltip="'All orders that are still not proccessed and occured during time period'"
            :subTitle="'New Orders'"
          />
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <MiniStatistic
            :icon="'close'"
            :color="'primary'"
            :title="canceled"
            :path="`/inf-crm?orders=canceled`"
            :tooltip="'All orders that are Canceled and occured during time period'"
            :subTitle="'Canceled Orders'"
          />
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <MiniStatistic
            :icon="'cached'"
            :color="'primary'"
            :title="proccessing"
            :path="`/inf-crm?orders=proccessing`"
            :tooltip="'All orders are in Proccessing and occured during time period'"
            :subTitle="'In Proccessing Orders'"
          />
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <MiniStatistic
            :icon="'done'"
            :color="'primary'"
            :title="confirmed"
            :path="`/inf-crm?orders=confirmed`"
            :tooltip="'All orders that are Confirmed and occured during time period'"
            :subTitle="'Confirmed Orders'"
          />
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <MiniStatistic
            :icon="'pending'"
            :color="'primary'"
            :title="pending"
            :path="`/inf-crm?orders=pending`"
            :tooltip="'All orders that are Pending and occured during time period'"
            :subTitle="'Pending Orders'"
          />
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <MiniStatistic
            :icon="'money'"
            :color="'primary'"
            :title="delivered"
            :path="`/inf-crm?orders=delivered`"
            :tooltip="'All orders that are Delivered and occured during time period'"
            :subTitle="'Delivered Orders'"
          />
        </v-flex>
        <v-flex xs12 md4 pa-1>
          <MiniStatistic
            :icon="'undo'"
            :color="'primary'"
            :title="returned"
            :path="`/inf-crm?orders=returned`"
            :tooltip="'All orders that are Returned and occured during time period'"
            :subTitle="'Returned Orders'"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="settings.home">
        <v-flex style="height:350px;" xs12 md12 pa-1>
          <v-card color="primary" dark>
            <v-card-title primary-title>
              Orders By Day Of Month
            </v-card-title>
            <v-card-text>
              <chartist
                :data="monthData.data"
                :options="monthData.options"
                :responsive-options="monthData.responsiveOptions"
                :type="'Bar'"
                style="max-height: 250px;"
              />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex style="height:350px;" xs12 md12 pa-1>
          <v-card color="primary" dark>
            <v-card-title primary-title>
              Orders By Time of Day
            </v-card-title>
            <v-card-text>
              <chartist
                :data="todayData.data"
                :options="todayData.options"
                :responsive-options="todayData.responsiveOptions"
                :type="'Bar'"
                style="max-height: 250px;"
              />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex style="height:350px;" xs12 md6 pa-1>
          <v-card color="primary" dark>
            <v-card-title primary-title>
              Countries
            </v-card-title>
            <v-card-text>
              <chartist
                :data="countriesData.data"
                :options="countriesData.options"
                :responsive-options="countriesData.responsiveOptions"
                :type="'Pie'"
                style="max-height: 250px;"
              />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex style="height:350px;" xs12 md6 pa-1>
          <v-card color="primary" dark>
            <v-card-title primary-title>
              Genders
            </v-card-title>
            <v-card-text>
              <chartist
                :data="genderData.data"
                :options="genderData.options"
                :responsive-options="genderData.responsiveOptions"
                :type="'Pie'"
                style="max-height: 250px;"
              />
            </v-card-text>
          </v-card>
        </v-flex>
        <!-- <v-flex style="height:350px;" xs12 md6 pa-1>
          <v-card color="primary" dark>
            <v-card-title primary-title>
              Year
            </v-card-title>
            <v-card-text>
              <chartist
                :data="test.data"
                :options="test.options"
                :responsive-options="test.responsiveOptions"
                :type="'Bar'"
                style="max-height: 250px;"
              />
            </v-card-text>
          </v-card>
        </v-flex> -->
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md6 pa-1 v-for="(lists, l) in Object.keys(productCounts)" :key="l+'-list'">
          <v-card color="primary" dark>
            <v-card-title primary-title>
              Top <span style="font-weight:bold;">&nbsp;{{lists.toUpperCase()}}&nbsp;</span> Products
              <v-spacer></v-spacer>
              <v-btn flat v-if="settings.crm" small
                @click="()=>{
                  if(!showPanels['panel_' + l]) {
                    showPanels['panel_' + l] = true
                  } else {
                    showPanels['panel_' + l] =! showPanels['panel_' + l]
                  }
                }" 
                color="white">expand
              </v-btn>
            </v-card-title>
            <v-card-text v-if="settings.home || showPanels['panel_' + l]">
              <v-layout row wrap align-center>
                <v-flex xs12 md12 pa-1>
                  <v-layout row wrap align-center>
                    <v-flex xs12 md4 pa-1 style="font-size:12px;font-weight:bold;">
                      IMG
                    </v-flex>
                    <v-flex xs12 md6 pa-1 style="font-size:12px;font-weight:bold;">
                      NAME/SKU
                    </v-flex>
                    <v-flex xs12 md2 pa-1 style="font-size:12px;font-weight:bold;">
                      COUNT
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md12 pa-1 v-for="(ps, o) in productCounts[lists]" :key="o+lists+'item'">
                  <v-layout row wrap align-center>
                    <v-flex xs12 md4 pa-1>
                      <v-tooltip top>
                        <template slot="activator">
                          <div class="crop">
                            <img :src="ps.img">
                          </div>
                        </template>
                        <img :src="ps.img" width="300px">
                      </v-tooltip>
                    </v-flex>
                    <v-flex xs12 md6 pa-1>
                      <v-tooltip top>
                        <template slot="activator">
                          {{ps.name_en}} <span style="font-size:9px;font-weight:light;"> {{ps.sku}}</span>
                        </template>
                        <div>{{ps.sku}}</div>
                        <div>{{ps.name_ar}}</div>
                      </v-tooltip>
                    </v-flex>
                    <v-flex xs12 md2 pa-1>
                      {{ps.count}}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <span v-show="false">{{interday}}{{countries}}{{gender}}</span>
    </v-container>
  </div>
</template>

<script>
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import {firebase, db, auth, store} from '@/fb';
import MiniStatistic from '../components/MiniStatistic';
import axios from 'axios';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import moment from 'moment';
const api = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {
  'Accept': 'application/json'
}
export default {
  components:{  MiniStatistic},
  props:["settings"],
  data() {
    return {
      showPanels:{panel_0:false, panel_1:false, panel_2:false, panel_3:false, panel_4:false},
      loading:false,
      revenue:false,
      selectedTotal:'total',
      test: {
        data: {
          labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 700, 895],
          ],
        },
        options: {
          plugins: [
            this.$chartist.plugins.tooltip({
              currency: '$',
              class: 'class1 class2',
              appendToBody: true
            })
          ],
          height:250,
          axisX: {
            showGrid: false,
          },
          low: 0,
          high: 1050,
          chartPadding: {
            top: 30,
            right: 5,
            bottom: 5,
            left: 5,
          },
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            seriesBarDistance: 0,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value[0]
              },
            },
          }],
        ],
      },
      todayData: {
        data: {
          labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
          series: [
            [230, 750, 450, 300, 280, 240, 200, 190],
          ],
        },
        options: {
          height:250,
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 30,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      countriesData: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          donut: true,
          donutWidth: 80,
          startAngle: 270,
          showLabel: true,
          responsiveOptions: [
            ['screen and (min-width: 640px)', {
              chartPadding: 30,
              labelOffset: 100,
              labelDirection: 'explode',
              labelInterpolationFnc: function(value) {
                return value;
              }
            }],
            ['screen and (min-width: 1024px)', {
              labelOffset: 80,
              chartPadding: 20
            }]
          ]
        },
      },
      genderData: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          donut: true,
          donutWidth: 80,
          startAngle: 270,
          showLabel: true,
        },
      },
      monthData: {
        data: {
          labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
          series: [
            [12, 17, 7, 17, 23, 18, 38, 12, 17, 7, 17, 23, 18, 38, 25],
          ],
        },
        options: {
          stackBars: true,
          height:250,
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 30,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      dates:[],
      selectedDate:null,
      filter:null,
    }
  },
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
    async loadOrders(cc, date){
      this.loading = true
      this.$store.state.inf_selected_date = date.text
      let a = await store.collection('leads')
      .where('company_code', '==', cc)
      .where('import_date', '>=', date.dd)
      .where('import_date', '<=', date.ee)
      .limit(1000)
      .get().then(x=>x.docs.map((y, i)=>{
        if(i==x.docs.length-1) this.last = y
        return {
          ...y.data(), 
          key:y.id,
        }
      }))
      this.$store.state.inf_orders = a
      this.loading = false
    },
    async getOderstatuses(){
      let a = await db.ref('orderstatuses').once('value').then(x=>x.val())
      let b = await db.ref('shippingstatuses').once('value').then(x=>x.val())
      if(a){
        let c = Object.values(a)
        let d = Object.values(b)
      }
    },
    async GenDates(){
      this.loading = true
      const date = new Date( new Date().getTime() )
      const start_today = moment(date).startOf('day').format('x');
      const end_today = moment(date).endOf('day').format('x');
      const start_yesterday = moment().add(-1, 'day').startOf('day').format('x');
      const end_yesterday = moment().add(-1, 'day').endOf('day').format('x');
      const start_week = moment().startOf('week').format('x');
      const end_week = moment().endOf('week').format('x');
      const start_last_week = moment().add(-1, 'week').startOf('week').format('x');
      const end_last_week = moment().add(-1, 'week').endOf('week').format('x');
      const start_month = moment().startOf('month').format('x');
      const end_month = moment().endOf('month').format('x');
      const start_last_month = moment().add(-1, 'month').startOf('month').format('x');
      const end_last_month = moment().add(-1, 'month').endOf('month').format('x');
      const start_quarter = moment().startOf('quarter').format('x');
      const end_quarter = moment().endOf('quarter').format('x');
      const start_year = moment().startOf('year').format('x');
      const end_year = moment().endOf('year').format('x');
      let dates = [
        {text:`Today`, from:start_today, to:end_today},
        {text:`Yesterday`, from:start_yesterday, to:end_yesterday},
        {text:`This Week`, from:start_week, to:end_week},
        {text:`Last Week`, from:start_last_week, to:end_last_week},
        {text:`This Month`, from:start_month, to:end_month},
        {text:`Last Month`, from:start_last_month, to:end_last_month},
        {text:`This Quarter`, from:start_quarter, to:end_quarter},
        {text:`This Year`, from:start_year, to:end_year},
      ].map(x=>{
        return {
          ...x,
          dd:new Date(parseInt(x.from)).toISOString(),
          ee:new Date(parseInt(x.to)).toISOString()
        }
      })
      this.dates = dates
      if(this.$store.state.user && !this.$store.state.inf_selected_date) {
        this.selectedDate = this.dates[0]
        this.$store.state.inf_selected_date = this.selectedDate.text
        this.getOderstatuses()
        this.loadOrders(this.$store.state.user.company_code, this.selectedDate)
      } else {
        this.selectedDate = this.dates.filter(x=>x.text == this.$store.state.inf_selected_date)[0]
        this.loading = false
      }
    },
    async getProducts() {
      let a = await db.ref('productsCoreLite').once('value').then(x=>x.val())
      if(a) {
        this.$store.state.productsLite = Object.values(a)
      }
    },
    calcTotal(os, total){
      if(os.length) {
        let s = os.filter(x=>x[total] && x[total]!='NaN').reduce((sum, a) => sum + parseInt(a[total]), 0)
        return `$${parseInt(s)}`;
      } else {
        return 0
      }
    }
  },
  computed:{
    items() {
      let role =  this.$store.state.role
      return this.$store.state.menu[role]
    },
    role () {
      return this.$store.state.role
    },
    inf(){
      return this.$store.state.inf
    },
    infsite(){
      return this.$store.state.user
    },
    orders(){
      let os = this.$store.state.inf_orders
      if(this.revenue) {
        return this.calcTotal(os, this.selectedTotal)
      } else {
        return os.length
      }
    },
    newOrders(){
      let os = this.$store.state.inf_orders.filter(x=>x.order_status == 'NEW')
      if(this.revenue) {
        return this.calcTotal(os, this.selectedTotal)
      } else {
        return os.length
      }
    },
    proccessing(){
      let os = this.$store.state.inf_orders.filter(x=>{
        let proccessing = ["1st NA", "2nd NA", "3rd NA", "call back", "NEED CHECK", "Call back After 11:00AM", "pending payment"]
        if(proccessing.includes(x.order_status)){
          return x
        }
      })
      if(this.revenue) {
        return this.calcTotal(os, this.selectedTotal)
      } else {
        return os.length
      }
    },
    canceled(){
      let os = this.$store.state.inf_orders.filter(x=>{
        let canceled = ["Cancel - CIM", "Cancel - No Answer", "Cancel - Duplicate", "Cancel - Price", "Cancel - Didn't need the order", "Cancel - Others", "Cancel ID", "Cancel wrong number", "cancel wrong person", "cancel NSA", "Cancel Whatsapp", "Cancel reject previous order", "Cancel - Didn't Request", "Cancel Delivery Fees", "Cancel - Corona (COVID-19)", "Cancel don't have Card ", "Cancel Combine"]
        if(canceled.includes(x.order_status)){
          return x
        }
      })
      if(this.revenue) {
        return this.calcTotal(os, this.selectedTotal)
      } else {
        return os.length
      }
    },
    confirmed(){
      let os =  this.$store.state.inf_orders.filter(x=>x.order_status == 'Confirmed')
      if(this.revenue) {
        return this.calcTotal(os, this.selectedTotal)
      } else {
        return os.length
      }
    },
    pending(){
      let os =  this.$store.state.inf_orders.filter(x=> x.order_status == 'Dispatch')
      if(this.revenue) {
        return this.calcTotal(os, this.selectedTotal)
      } else {
        return os.length
      }
    },
    delivered(){
      let os =  this.$store.state.inf_orders.filter(x=>x.shipping_status == 'Delivered' || x.shipping_status == 'Paid')
      if(this.revenue) {
        return this.calcTotal(os, this.selectedTotal)
      } else {
        return os.length
      }
    },
    returned(){
      let os =  this.$store.state.inf_orders.filter(x=>x.shipping_status == 'Returned')
      if(this.revenue) {
        return this.calcTotal(os, this.selectedTotal)
      } else {
        return os.length
      }
    },
    interday(){
      let f = this.$store.state.inf_orders//.filter(x=>{if(this.filter) return x.order_status == this.filter})
      let dates = {}
      let times = {}
      f.forEach(x=>{
        if(!dates[`${new Date(x.import_date).getDate()}`]) {
          dates[`${new Date(x.import_date).getDate()}`] = 0
        }
        dates[`${new Date(x.import_date).getDate()}`] += 1
        if(!times[`${new Date(x.import_date).getHours()}`]) {
          times[`${new Date(x.import_date).getHours()}`] = 0
        }
        times[`${new Date(x.import_date).getHours()}`] += 1
      })
      if(Object.keys(dates).length) {
        let vs = Object.values(dates)
        let ts = Object.values(times)
        this.monthData.data.labels = Object.keys(dates)
        this.monthData.data.series = [vs.map(x=>x.toString())]
        this.monthData.options.high = vs.sort((a, b)=> b - a)[0] + 2
        this.todayData.data.labels = Object.keys(times)
        this.todayData.data.series = [ts.map(x=>x.toString())]
        this.todayData.options.high = ts.sort((a, b)=> b - a)[0] + 2
        
      }
      return dates
    },
    productCounts(){
      let allproducts = {}
      let alldelivered = {}
      let allcanceled = {}
      let allreturned = {}
      let f = this.$store.state.inf_orders
      f.forEach(x=>{
        if(x.order)
        x.order.forEach(it=>{
          if(!it.product.toLowerCase().includes('deliverey') && !it.product.toLowerCase().includes('delivery')) {
            if(!allproducts[it.sku]) {
              allproducts[it.sku] = 0
            }
            allproducts[it.sku] += 1
          }
        })
      })
      let returned = f.filter(x=>x.shipping_status == 'Returned')
      let delivered = f.filter(x=>x.shipping_status == 'Delivered' || x.shipping_status == 'Paid')
      let canceled = f.filter(x=>{
        let canceled = ["Cancel - CIM", "Cancel - No Answer", "Cancel - Duplicate", "Cancel - Price", "Cancel - Didn't need the order", "Cancel - Others", "Cancel ID", "Cancel wrong number", "cancel wrong person", "cancel NSA", "Cancel Whatsapp", "Cancel reject previous order", "Cancel - Didn't Request", "Cancel Delivery Fees", "Cancel - Corona (COVID-19)", "Cancel don't have Card ", "Cancel Combine"]
        if(canceled.includes(x.order_status)){
          return x
        }
      })
      returned.forEach(x=>{
        if(x.order)
        x.order.forEach(it=>{
          if(!it.product.toLowerCase().includes('deliverey') && !it.product.toLowerCase().includes('delivery')) {
            if(!allreturned[it.sku]) {
              allreturned[it.sku] = 0
            }
            allreturned[it.sku] += 1
          }
        })
      })
      delivered.forEach(x=>{
        if(x.order)
        x.order.forEach(it=>{
          if(!it.product.toLowerCase().includes('deliverey') && !it.product.toLowerCase().includes('delivery')) {
            if(!alldelivered[it.sku]) {
              alldelivered[it.sku] = 0
            }
            alldelivered[it.sku] += 1
          }
        })
      })
      canceled.forEach(x=>{
        if(x.order)
        x.order.forEach(it=>{
          if(!it.product.toLowerCase().includes('deliverey') && !it.product.toLowerCase().includes('delivery')) {
            if(!allcanceled[it.sku]) {
              allcanceled[it.sku] = 0
            }
            allcanceled[it.sku] += 1
          }
        })
      })
      let rs = [ allproducts, allcanceled, alldelivered, allreturned ]
      let rns = [ 'ordered', 'canceled', 'delivered', 'returned' ]
      let sortedCounters = {}
      rs.forEach((counter, i)=>{
        var sortable = [];
        for (var count in counter) {
            sortable.push([count, counter[count]]);
        }
        sortable.sort(function(a, b) {
            return b[1] - a[1];
        });
        sortedCounters[rns[i]] = sortable.slice(0, 3)
      })
      let allDisplay = {}
      let kss = Object.keys(sortedCounters)
      Object.values(sortedCounters).forEach((group, i)=>{
        group.forEach(item=>{
          let fp = this.$store.state.productsLite.filter(x=>x.sku == item[0])
          if(!allDisplay[kss[i]]) allDisplay[kss[i]] = []
          if(fp.length) {
            allDisplay[kss[i]].push({sku:item[0], count:item[1], ...fp[0]})
          }
        })
      })
      return allDisplay
    },
    countries(){
      let a = this.$store.state.inf_orders.map(x=>{return{country:x.country}})
      let countries = {}
      let total = 0
      a.forEach(o=>{
        if(!countries[o.country]) countries[o.country] = 0
        countries[o.country] += 1
        total += 1
      })
      if(a&&a.length&&Object.keys(countries).length) {
        let ks = Object.keys(countries)
        let vs = Object.values(countries)
        this.countriesData.data.labels = ks.map((x, i)=> `${x}-${vs[i]}(${parseInt(vs[i]/total*100)}%)`)
        let cc = ['lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite']
        this.countriesData.data.series = vs.map((x, i)=>{return {value: x, className: cc[i]}})
      }
      return countries
    },
    gender(){
      let a = this.$store.state.inf_orders.map(x=>{return{gender:x.gender}}).filter(x=>x.gender)
      let genders = {}
      let total = 0
      a.forEach(o=>{
        if(!genders[o.gender]) genders[o.gender] = 0
        genders[o.gender] += 1
        total += 1
      })
      if(a&&a.length&&Object.keys(genders).length) {
        let ks = Object.keys(genders)
        let vs = Object.values(genders)
        let cc = ['lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite', 'lightWhite', 'darkWhite', 'medWhite']
        this.genderData.data.labels = ks.map((x, i)=> `${x}-${vs[i]}(${parseInt(vs[i]/total*100)}%)`)
        this.genderData.data.series = vs.map((x, i)=>{return {value: x, className: cc[i]}})
      }
      return genders
    },
  },
  async created() {
    if(this.$store.state.user) {
      this.GenDates()
      this.getProducts()
    }
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style>
.crop {
    width: 80%;
    height: 70px;
    overflow: hidden;
}

.crop img {
    width: 100%;
}
.ct-series-a {
  /* give the donut slice a custom colour */
  stroke: #fff !important;
  /* customize stroke width of the donut slices in CSS. Note that this property is already set in JavaScript and label positioning also relies on this. In the right situation though it can be very useful to style this property. You need to use !important to override the style attribute */
  stroke-width: 4px !important;
  /* create modern looking rounded donut charts */
  stroke-linecap: round;
}

.ct-series-a .ct-bar, .ct-series-a .ct-line, .ct-series-a .ct-point, .ct-series-a .ct-slice-donut {
    stroke: #fff;
}
.ct-series-b .ct-bar, .ct-series-b .ct-line, .ct-series-b .ct-point, .ct-series-b .ct-slice-donut {
    stroke: #fff;
}
.ct-chart {
    margin: auto;
    height: 200px;
}
.ct-label {
  color: #fff !important;
  font-weight: bold;
}

.ct-grids line {
  stroke: rgb(255, 255, 255, 30%) !important;
}

svg.ct-chart-bar, svg.ct-chart-line{
	overflow: visible;
}

.ct-line,
.ct-bar {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 1s linear forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

.darkWhite {
  stroke: rgb(255 255 255 / 98%);
}

.medWhite {
  stroke: rgb(255 255 255 / 90%);
}

.lightWhite {
  stroke: rgb(255 255 255 / 82%);
}
</style>
